import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/lib/images";
import { staggerContainer, staggerItem } from "@/components/motion/Reveal";

const STRAPS = [
  { name: "Cielo", color: "#2E9EF0" },
  { name: "Navy", color: "#12263A" },
  { name: "Sol", color: "#FFC533" },
  { name: "Coral", color: "#FF6B57" },
  { name: "Menta", color: "#3CB878" },
];

export default function KidsSection() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section className="bg-[#12263A] overflow-hidden">
      <div className="max-w-6xl mx-auto px-5 py-20 md:py-28 grid md:grid-cols-2 gap-12 items-center">
        <motion.div
          ref={ref}
          style={{ y }}
          className="border-2 border-[#F3F2F2] overflow-hidden bg-[#F3F2F2] order-2 md:order-1"
          initial={{ borderRadius: "32px" }}
        >
          <img src={IMAGES.watchStraps} alt="Reloj Kiddio con correas de colores intercambiables" className="w-full h-auto object-cover" />
        </motion.div>

        <div className="order-1 md:order-2">
          <motion.span
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.6 }}
            className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#FFC533]"
          >
            Para los peques
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 26 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.08 }}
            className="mt-3 text-[28px] md:text-[44px] font-black text-[#F3F2F2] leading-[1.05]"
            style={{ letterSpacing: "-0.02em" }}
          >
            Que se vea tan cool como se siente.
          </motion.h2>
          <p className="mt-5 text-[17px] leading-[1.6] text-[#D6D9DC] max-w-md">
            Cambia la correa según su humor del día. Se quitan y se ponen en un segundo,
            sin herramientas. Porque un reloj que mola es un reloj que sí quieren llevar.
          </p>

          <motion.div
            variants={staggerContainer} initial="hidden" whileInView="show" viewport={{ once: true }}
            className="mt-8 flex flex-wrap gap-3" data-testid="strap-swatches"
          >
            {STRAPS.map((s) => (
              <motion.div key={s.name} variants={staggerItem} className="flex flex-col items-center gap-2">
                <span
                  className="w-14 h-14 border-2 border-[#F3F2F2] hover:scale-110 transition-transform"
                  style={{ backgroundColor: s.color, borderRadius: "31%" }}
                  aria-label={`Correa ${s.name}`}
                />
                <span className="text-[12px] font-bold text-[#D6D9DC]">{s.name}</span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
